<section class="helpsection">
    <div class="helpheader">
        <strong>Help Documentation</strong>
    </div>
    <div style="padding-left: 2%;">
        <strong class="help">Find Answers and Learn More</strong>
        <p class="parahelp">Below are helpful resources to guide you through using the PBC Data Submission Portal. Click to view or download
documentation, watch training videos, or access quick guides.
</p>
    </div>
    <hr >
    <div class="subsection">
        <div class="helplist">
            <img class="iconImg" src="/assets/icons/video.svg">
            <div class="list">
                <span class="helplisttitle">Residential Training Video</span><br>
                    <span class="helplistsubtitle">
                        Watch an introduction <a href="javascript:void(0)" (click)="downloadDataFile('rs_welcome_video')">training video</a>
                    </span>
                    <span class="disclaimer"> (To view this downloaded training video, you will need a compatible media player (such as VLC, Windows Media Player, or QuickTime) that supports MP4 files on your device.)</span>
            </div>
        </div>
        <div class="helplist">
            <img class="iconImg" src="/assets/icons/pdf.svg">
            <div class="list">
                <span class="helplisttitle">PBC Data Submission Portal Overview</span><br>
                    <span class="helplistsubtitle">
                        Download the <a href="javascript:void(0)" (click)="downloadDataFile('pbc_tool_overview')">help documentation</a> 
                    </span>
            </div>
        </div>
        <div class="helplist">
            <img class="iconImg" src="/assets/icons/global.svg">
            <div class="list">
                <span class="helplisttitle">MyODP Website</span><br>
                <a href="https://home.myodp.org/resources/waiver-implementation/performance-based-contracting/" target="_blank" rel="noopener noreferrer" style="font-weight:500; font-size: 15px !important; text-decoration: none; text-decoration: underline;">
                    Performance-Based Contracting – MyODP
                </a>
                <!-- <span class="helplistsubtitle">
                    Download the help documentation for completing the SCO questions 
                    <a href="javascript:void(0)" (click)="downloadDataFile('sco_questionnaire_form_overview')">here</a>.
                </span> -->
            </div>
        </div>
    </div>
    <hr>
    <div style="padding-left: 2%;">
        <strong class="help">Need more help?</strong>
        <p class="sectionend">
        <a routerLink="/contact" style="text-decoration: underline; cursor: pointer;">Contact Us</a>
    </p>
    </div>
</section>